<ng-template let-row="row" let-icon="value">
    <app-icon-table-cell-inside [iconData]="icon"></app-icon-table-cell-inside>
</ng-template>
